/**
 * Open-redirect guard for the post-login round-trip.
 *
 * Only same-origin, in-app paths are honored as a redirect target; anything
 * else falls back to '/'. The destination travels through URLs the user can
 * influence (Login's redirect_url → OAuth state → callback's ?redirect), so a
 * weak check could be turned into an open redirect to an attacker site.
 *
 * A path is safe only if it:
 *   - starts with a single '/' (not '//', which is protocol-relative →
 *     cross-origin), and
 *   - contains no backslashes or whitespace/control chars — browsers strip
 *     these from URLs, which can smuggle '/\t//evil.com' past a naive check
 *     and resolve to a cross-origin navigation.
 *
 * The backend independently re-validates the same way (auth.py azure_callback
 * urlparse scheme/netloc check) — this is the client-side half of that guard.
 */
const SAFE_IN_APP_PATH = /^\/(?!\/)[^\\\s]*$/

export function safeRedirect(path: string | undefined | null): string {
  if (!path || !SAFE_IN_APP_PATH.test(path)) return '/'
  // Never bounce back to the login page itself (redirect loop).
  if (path === '/login' || path.startsWith('/login?') || path.startsWith('/login/')) return '/'
  return path
}
